<template>
  <div class="post">
    <van-nav-bar :title="topTitle" :rightText="lang.topclear" :left-arrow="!$route.query.fromapp" @click-left="prev()" @click-right="clear()" />
    <div class="tit">
      <span class="num">3</span>
      <span class="titname">{{lang.propertyTypeAndAddress}}</span>
    </div>
    <!-- form -->
    <van-cell-group>
      <!-- 楼盘类型 -->
      <van-cell :title="lang.propertyType" is-link @click="chooseType=true" :value="subCategoryText == '' ? Categorytxt : `${Categorytxt}-${subCategoryText}`" required class="maxw" />
      <van-popup v-model="chooseType" class="choose" :overlay="false">
        <van-nav-bar :title="lang.propertyType" class="spaing" left-arrow @click-left="closeCate" />
        <div v-for="(title,index) in DhouseType" :key="index">
          <van-cell :title="title.dictionaryNameWithCulture" :is-link="title.children ? true : false " @click="childrenShow(title)" />
        </div>
        <van-popup v-model="chooseChild" class="choose" :overlay="false">
          <van-nav-bar :title="lang.propertyType" left-arrow @click-left="exit" class="spaing" :right-text="lang.confirm" @click-right="confrimCate" />
          <van-checkbox-group v-model="PropertyInfo.subCategory">
            <van-cell v-for="(item,index) in DhouseTypeChild" :key="index" :title="item.dictionaryNameWithCulture" @click="toggle(index,item)">
              <van-checkbox :name="item.dictionaryValue" ref="checkboxes" checked-color="#ED1818" :value="item.dictionaryNameWithCulture" />
            </van-cell>
          </van-checkbox-group>
        </van-popup>
      </van-popup>
      <!-- 屋苑或大厦名 -->
      <van-cell :title="lang.estateOrBuildingName" :value="url.indexOf('en-us') > -1 ? PropertyInfo.estateNameEN : PropertyInfo.estateName" required v-if="$route.query.type == 'edit'" />
      <van-cell :title="lang.estateOrBuildingName" is-link @click="Search()" :value="url.indexOf('en-us')> -1 ? PropertyInfo.estateNameEN : PropertyInfo.estateName" required v-else />
      <!-- 屋苑期数 楼盘类型为bigster  -->
      <van-cell v-model="PropertyInfo.phaseWithCulture" :title="lang.housenum" input-align="right" v-if="$route.query.type=='edit' && PropertyInfo.phaseWithCulture" />
      <van-cell v-model="PropertyInfo.phaseWithCulture" :title="lang.housenum" input-align="right" @click="houseNumShow = true" is-link v-if="PropertyInfo.estateType == 'bigest' && getPhasesuccess " />
      <van-popup v-model="houseNumShow" class="choose" position="top" :overlay="false">
        <van-nav-bar :title="lang.housenum" left-arrow @click-left="houseNumShow = false" :right-text="lang.confirm" @click-right="houseNumShow = false" />
        <van-radio-group v-model="PropertyInfo.phaseWithCulture">
          <van-cell :title="item.phaseWithCulture" clickable v-for="item in PropertyInfo.housenumArr" :key="item.value" @click="setphase(item)">
            <van-radio :name="item.phaseWithCulture" checked-color="#ED1818" @click.stop="setphase(item)" />
          </van-cell>
        </van-radio-group>
      </van-popup>
      <!-- 座數及單位 -->
      <van-field v-model="PropertyInfo.buildingName" :label="lang.towerAndUnit" input-align="right" class="maxw" maxlength="20" type="text" @click="post.goPosition($event,$route.query.fromapp)" />
      <!-- 物业地址  如果是搜索禁止修改 -->
      <van-field v-model="PropertyInfo.estateAddressEN" :label="lang.propertyAddress" input-align="right" class="maxw" maxlength="50" type="text" v-if="url.indexOf('en-us')>-1 ? true : false" @click="post.goPosition($event,$route.query.fromapp)" />
      <van-field v-model="PropertyInfo.estateAddress" :label="lang.propertyAddress" input-align="right" class="maxw" maxlength="50" type="text" v-else @click="post.goPosition($event,$route.query.fromapp)" />
    </van-cell-group>
    <!-- next -->
    <div class="next">
      <van-button class="nextBtn" @click="prev">{{lang.prev}}</van-button>
      <van-button class="nextBtn" @click="next" :class="{'opc':VerifyNext}">{{lang.next}}</van-button>
    </div>
  </div>
</template>

<script>
// import { Toast, Dialog } from "vant";
import { mapState, mapMutations } from "vuex";
import lang from "./../../../common/language/post";
import post from "./../../../common/js/post"
export default {
  name: "step3",
  data () {
    return {
      lang,
      post,
      topTitle: "",
      getPhasesuccess: false,
      chooseType: false, //遮罩 父
      chooseChild: false, //遮罩 子
      DhouseType: [],
      DhouseTypeChild: [],
      housenum: "",
      houseNumShow: false,
      Categorytxt: "",
      subCategoryText: "",
      housenumArr: [], //屋苑期数配置
      housenumText: "",
      phaseShow: false,
      url: document.URL,
      query: '',
      PropertyInfo: {
        estateType: "",
        propertyCategory: "", // 放盘分类Int32
        subCategory: [], //小分类In32
        estateAddress: "",
        estateAddressEN: '',
        buildingName: "",
        estateName: "", // 屋苑名称
        phaseWithCulture: "" //屋苑期数
      }
    };
  },
  created () {
    this.topTitle = post.getTitle(this, this.lang)
    this.getDictionary();
    if (this.propertyInfo) {
      this.getState(); // 获取数据
    }
    if (this.PropertyInfo.parentID) {
      this.getPhase(this.PropertyInfo.parentID);
    }
  },
  watch: {
    PropertyInfo: {
      handler (val, oldVal) {
        if (val.propertyCategory) {
          this.Categorytxt = this.getDictionaryText(val.propertyCategory, this.DhouseType);
          this.PropertyInfo.propertyCategory = val.propertyCategory;
          if (val.propertyCategory == 4) { this.setSign({ IsParking: true }); }
          else { this.setSign({ IsParking: false }); }
        }
      },
      deep: true
    },
    "PropertyInfo.subCategory" (num) {
      if (JSON.stringify(num) == "[]") {
        this.subCategoryText = ''
      } else {
        if (this.PropertyInfo.subCategory.length > 2) {
          this.$toast(lang.onlyCategories);
          this.PropertyInfo.subCategory = this.PropertyInfo.subCategory.slice(0, 2);
        }
        //  公屋居屋只能2选1
        if (this.PropertyInfo.subCategory.indexOf("7") > -1 && this.PropertyInfo.subCategory.indexOf("6") > -1) {
          this.PropertyInfo.subCategory = this.PropertyInfo.subCategory.splice(1, 1);
        }
        // 如果存在 公屋||居屋 显示
        if (this.PropertyInfo.subCategory.indexOf("7") > -1 || this.PropertyInfo.subCategory.indexOf("6") > -1) {
          this.setSign({ greenWhiteShow: true });
        } else {
          this.setSign({ greenWhiteShow: false });
        }
        this.subCategoryText = this.getDictionaryText(num, this.DhouseTypeChild);
      }
      this.setProperty(this.PropertyInfo);
    }
  },
  computed: {
    ...mapState(["propertyInfo", "sign", "dictionary", 'showBtn']),
    VerifyNext () {
      if (this.Categorytxt && this.PropertyInfo.estateName) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapMutations(["setProperty", "stepChange", "setSign", "clearStep3"]),
    closeCate () {
      if (JSON.stringify(this.DhouseTypeChild) !== "[]" && JSON.stringify(this.PropertyInfo.subCategory) == "[]") {
        this.Categorytxt = "";
        this.subCategoryText = "";
        this.PropertyInfo.propertyCategory = [];
        this.setProperty(this.PropertyInfo);
      }
      this.chooseType = false;
    },
    getState () {
      this.PropertyInfo = Object.assign({}, this.propertyInfo);
      if (this.$route.query.type == "copy" && this.propertyInfo.phaseWithCulture !== null && this.propertyInfo.phaseWithCulture !== '') {
        this.PropertyInfo.parentID = this.propertyInfo.parentEstateID;
        this.PropertyInfo.estateType = "bigest";
      }
      if (this.PropertyInfo.subCategory == undefined || JSON.stringify(this.PropertyInfo.subCategory) == "[]") {
        this.$set(this.PropertyInfo, "subCategory", []);
      }
      // // 通过 修改 或者 拷贝进入页面 subCate 是个对象 特殊处理
      if (this.$route.query.type == "edit" || this.$route.query.type == "copy") {
        if (this.PropertyInfo.subCategory.constructor === Object) {
          this.PropertyInfo.subCategory = Object.keys(this.PropertyInfo.subCategory);
        }
      }
      post.getQuery(this)
    },
    // 期数请求
    getPhase (EstateId) {
      this.axios
        .post(this.pub.getApi().SearchEstateSuggester, {
          parentEstateId: EstateId,
          order: 'PhaseSequenceAsc', // 按期数排序
          pageIndex: 1,
          pageCount: 20
        })
        .then(res => {
          if (res.data.code == 0 && res.data.result) {
            let reuslt = res.data.result.data;
            this.getPhasesuccess = true
            this.$set(this.PropertyInfo, "housenumArr", reuslt);
          }
        });
    },
    getDictionary () {
      for (let key in this.dictionary) {
        if (key == "PropertyCategory") {
          this.DhouseType = this.dictionary[key].children;
        }
      }
    },
    getDictionaryText (value, Dictionary) {
      if ((typeof value == "object" && JSON.stringify(value) !== "[]") || Dictionary == this.DhouseTypeChild) {
        this.DhouseTypeChild = this.DhouseType.find(item => {
          return item.dictionaryValue == this.PropertyInfo.propertyCategory;
        }).children;
        let textArr = [];
        for (let i = 0; i < value.length; i++) {
          textArr.push(this.DhouseTypeChild.filter(item => item.dictionaryValue == value[i])[0].dictionaryNameWithCulture);
        }
        return textArr.join(",");
      } else if (typeof value == "object") {
        let textArr = [];
        for (let i = 0; i < value.length; i++) {
          textArr.push(
            this.Dictionary.filter(item => item.dictionaryValue == value[i])[0]
              .dictionaryNameWithCulture
          );
        }
        return textArr.join(",");
      } else {
        return Dictionary.find(item => {
          if (item.dictionaryValue == value) {
            return item;
          }
        }).dictionaryNameWithCulture;
      }
    },
    prev () {
      this.setProperty(this.PropertyInfo);
      if (this.propertyInfo.propertySource == "1") {
        this.$router.push('/post/step1/' + this.query)
        this.stepChange(1);
      } else {
        this.$router.push('/post/step2/' + this.query)
        this.stepChange(2);
      }
    },
    next () {
      if (this.validate_required()) {
        this.stepChange(4);
        this.$router.push('/post/step4/' + this.query)
        this.setProperty(this.PropertyInfo);
      }
    },
    childrenShow (data) {
      // 子元素
      if (this.PropertyInfo.propertyCategory != data.dictionaryValue) {
        this.PropertyInfo.subCategory = [];
        this.subCategoryText = "";
      }
      this.PropertyInfo.propertyCategory = data.dictionaryValue; // 获取父value
      this.Categorytxt = data.dictionaryNameWithCulture; // 获取父txt

      if (data.children) {
        this.subCategoryText = '';
        this.chooseChild = true;
        this.DhouseTypeChild = data.children;
      } else {
        this.setSign({ greenWhiteShow: false });
        this.chooseType = false;
        this.chooseChild = false;
        this.DhouseTypeChild = [];

      }
      this.setProperty(this.PropertyInfo);
    },
    toggle (index, item) {
      this.$refs.checkboxes[index].toggle();
    },
    confrimCate () {
      this.chooseChild = false;
      this.chooseType = false;
    },
    exit () {
      this.chooseChild = false;
      this.childType = [];
    },
    validate_required () {
      if (!this.Categorytxt) {
        this.$notify(lang.require3.propertyType);
        return;
      }
      if (!this.PropertyInfo.estateName) {
        this.$notify(lang.require3.estateOrBuildingName);
        return;
      }
      return true;
    },
    clear () {
      this.$dialog.confirm({
        title: lang.Clearcontent,
        cancelButtonText: lang.cancel,
        confirmButtonText: lang.confirm
      })
        .then(() => {
          //  1.清空 vuex 中的数据
          this.clearStep3();
          //  2. 清空本页面的v-model 的数据
          if (this.$route.query.type == "edit") {
            this.Categorytxt = "";
            this.housenumText = "";
            this.subCategoryText = "";
            this.PropertyInfo.propertyCategory = "";
            this.PropertyInfo.subCategory = [];
            this.PropertyInfo.buildingName = "";
            this.PropertyInfo.estateAddress = "";
            this.PropertyInfo.estateAddressEN = "";
          } else {
            this.Categorytxt = "";
            this.housenumText = "";
            this.subCategoryText = "";
            this.PropertyInfo.propertyCategory = "";
            this.PropertyInfo.subCategory = [];
            this.PropertyInfo.estateAddress = "";
            this.PropertyInfo.estateAddressEN = "";
            this.PropertyInfo.buildingName = "";
            this.PropertyInfo.estateName = "";
            this.PropertyInfo.estateNameEN = "";
            this.PropertyInfo.phaseWithCulture = ""; //屋苑期数
            this.PropertyInfo.estateType = ""; //屋苑类型
            this.PropertyInfo.gscopeCode = '';
            this.PropertyInfo.gscopeCodeText = '';
            this.PropertyInfo.gscopeNameWithCulture = '';
          }
        })
    },
    setphase (item) {
      this.PropertyInfo.phaseWithCulture = item.phaseWithCulture;
      this.PropertyInfo.estateID = item.estateID; // 如果存在期数 替换掉 ID 为带楼盘期数的ID
      // 根据带期数的ID 去获取物业地址
      this.axios
        .get(this.pub.getApi().GetEstate, {
          params: {
            estateId: item.estateID
          }
        })
        .then(res => {
          if (res.data.code == 0 && res.data.result) {
            this.PropertyInfo.estateAddress = res.data.result.detailAddressWithCulture
            if (this.url.indexOf('en-us') > -1) {
              this.PropertyInfo.estateAddress = ""
              this.PropertyInfo.estateAddressEN = res.data.result.detailAddressWithCulture
            }
          }
        });
    },
    Search () {
      this.$router.push('/prop-search/' + this.query)
    }
  },
  beforeDestroy () {
    this.setProperty({ ...this.PropertyInfo });
  },
  // components: {
  //   //   [Toast.name]: Toast,
  //   [Dialog.name]: Dialog
  // }
};
</script>

<style lang="scss" scoped>
.opc {
  opacity: 0.5;
}
.post {
  height: 100%;
}
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
.spaing {
  margin-bottom: 15px;
}
.choose {
  width: 100%;
  height: 100%;
  background: #f5f6f7;
}
// 修改vant label 宽度
.maxw {
  /deep/.van-field__label,
  /deep/.van-cell__title {
    max-width: 120px;
  }
}
/deep/ .van-cell__value {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 170px;
  height: 24px;
  display: inline-block;
}
</style>
